import { type App } from "vue";
import { type Pinia } from "pinia";
import { type Router } from "vue-router";
import * as Sentry from "@sentry/vue";
import { apiClient } from "@/client";
import { retryingTransport } from "@/sentry-transport";
import { APIProperties } from "@/type/api";

export async function Init(app: App, pinia: Pinia) {
	const api_info: APIProperties = await apiClient.JSONGet("/api");
	Sentry.init({
		app,
		dsn: api_info.sentry_dsn,
		// Envelopes go to our own host and are forwarded to the ingest service
		// (api/sentry_tunnel.go). A direct cross-origin post is refused by the
		// browser unless the ingest service answers CORS for every origin that
		// serves the SPA.
		tunnel: "/api/sentry-tunnel",
		// The tunnel's upstream is our own backend, which restarts under the
		// dev supervisor and on every deploy; retry across that gap instead of
		// letting the SDK's one-shot send drop the report.
		transport: retryingTransport,
		//integrations: [Sentry.browserTracingIntegration({ router })],
		environment: api_info.environment,
		release:
			api_info.version.revision +
			(api_info.version.is_modified ? "-dirty" : ""),
		tracesSampleRate: 0.01,
	});
	pinia.use(Sentry.createSentryPiniaPlugin());
	console.log("sentry initialized", api_info.sentry_dsn, api_info.environment);
}
